module.exports = __webpack_public_path__ + "img/2.55894281.jpg";